import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import cx from 'classnames';
import SectionWrapper, {
  type OwnProps as SectionWrapperProps
} from '@/home/common/SectionWrapper';
import { InternalLinkType } from './InternalLinks.types';

export const SEOSectionWrapper = createComponent<
  ElementWithProps<SectionWrapperProps>
>(SectionWrapper, () => ({
  className:
    'grid w-full flex-col gap-3xl py-4xl md:grid-cols-2 md:gap-2xl md:py-7xl lg:py-8xl'
}));

export const CategoryHeader = createComponent('div', {
  className: 'flex flex-col gap-lg sm:gap-xl md:shrink-0 md:flex-row md:gap-lg'
});

export const BrowseByLabel = createComponent('h2', {
  className: 'text-text-strong t-heading-xl md:t-heading-2xl'
});

export const TabsContainer = createComponent('div', {
  className: 'flex flex-col gap-sm md:gap-lg'
});

export const TabButton = createComponent<
  ElementWithProps<{ isActive: boolean }>
>('button', props => ({
  className: cx(
    'w-fit cursor-pointer whitespace-nowrap border-0 bg-transparent p-0 text-left t-heading-lg md:max-w-[350px] md:whitespace-normal md:t-heading-2xl lg:max-w-none lg:whitespace-nowrap',
    props.isActive
      ? 'text-text-primary hover:text-text-primary'
      : 'text-text-inverse-hover hover:text-text-inverse-hover'
  )
}));

export const TabButtonsWrapper = createComponent('div', {
  className: 'flex flex-col gap-sm md:gap-lg'
});

export const TabContentContainer = createComponent<
  ElementWithProps<{ isExpanded: boolean }>
>('div', props => ({
  className: cx('inline-grid', {
    'max-h-[92px] overflow-hidden md:max-h-none md:overflow-visible':
      !props.isExpanded
  })
}));

export const TabWrapper = createComponent<
  ElementWithProps<{ tabId: InternalLinkType; isActive: boolean }>
>('div', props => ({
  className: cx(
    'col-span-full row-span-full overflow-hidden transition-opacity',
    {
      'md:flex md:items-start md:pr-4xl':
        props.tabId === InternalLinkType.BodyStyle,
      'pointer-events-none invisible h-0 opacity-0': !props.isActive
    }
  )
}));

export const LinkGrid = createComponent<
  ElementWithProps<{ tabId: InternalLinkType }>
>('div', props => ({
  className: cx(
    'grid items-start justify-items-start gap-x-2xl gap-y-xl sm:gap-x-2xl sm:gap-y-xl md:gap-x-2xl md:gap-y-xl',
    {
      'grid-cols-2 sm:grid-cols-1': props.tabId === InternalLinkType.BodyStyle,
      'grid-cols-2': props.tabId === InternalLinkType.PopularMakesModels,
      'grid-cols-1 sm:grid-cols-2':
        props.tabId === InternalLinkType.TopLocations
    }
  ),
  'data-testid': 'internal-links-content'
}));
